import { AutogenLayoutCbsaLocationQuickInfo } from "./autogen/AutogenLayoutCbsaLocationQuickInfo";

export class CbsaLocationQuickInfo extends AutogenLayoutCbsaLocationQuickInfo {
    sourceLocationOnDisplay() {
        this.buttonViewLocation.link = `lme/dispatch/Location?mode=update&key=${this.mainDataSource.activeRow?.getString("id", null)}`
    }
}
